var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';

import { Translate } from "../../../../../I18N";
import { InputField } from "../../../../Components/Forms";








const FormInput = (data, formProps) => {
  const { register, setValue, submitting, getFieldState } = formProps;
  const { error } = getFieldState(data.cell.getValue());
  const hasErrors = Boolean(error);
  const reset = () => setValue(data.cell.getValue(), '', { shouldDirty: true });
  const { onChange, onBlur, name, ref } = register(data.cell.getValue(), { required: true });

  return /*#__PURE__*/(
    _jsx("div", {}, void 0, /*#__PURE__*/
    React.createElement(InputField, {
      id: data.cell.getValue(),
      label: data.cell.row.original.language,
      hideLabel: true,
      disabled: submitting,
      clearFieldAction: reset,
      errorMessage: hasErrors ? /*#__PURE__*/_jsx(Translate, {}, void 0, "This field is required") : '',
      onChange: onChange,
      onBlur: onBlur,
      name: name,
      ref: ref }
    )
    ));

};

export { FormInput };